// assets/js/api/ApiService.js

import { appConfig } from '../config.js';
import { loaderService } from '../utils/LoaderService.js';

class ApiService {
  constructor() {
    this.baseUrl = appConfig.apiBaseUrl;
    // --- RIMOSSO --- Non gestiamo più il token manualmente.
  }

  /**
   * Metodo privato per eseguire tutte le richieste API.
   * Ora si affida ai cookie HttpOnly per l'autenticazione.
   */
  async _request(endpoint, options = {}) {
    const url = `${this.baseUrl}${endpoint}`;
    const skipLoader = options.skipLoader || false;

    if (!skipLoader) {
      loaderService.show();
    }

    const headers = {
      'Accept': 'application/json',
      ...options.headers,
    };

    // --- RIMOSSO --- La logica per aggiungere l'header 'Authorization' non è più necessaria.

    // Gestione FormData vs JSON
    if (options.body instanceof FormData) {
      delete headers['Content-Type'];
    } else if (options.body) {
      if (!headers['Content-Type']) {
        headers['Content-Type'] = 'application/json';
      }
      options.body = JSON.stringify(options.body);
    }

    const config = {
      ...options,
      headers: headers,
      // Questa opzione è la chiave: dice al browser di inviare i cookie
      // associati al dominio dell'API, anche se la richiesta è cross-origin.
      credentials: 'include'
    };

    try {
      const response = await fetch(url, config);

      if (response.status === 204) {
        return null; // Risposta vuota (es. DELETE)
      }

      const responseData = await response.json().catch(() => {
        throw new Error(`Errore del server (status: ${response.status}). Risposta non valida.`);
      });

      if (!response.ok) {
        // --- MODIFICATO ---
        // Rimuoviamo il logout forzato da qui.
        // Ora è responsabilità del chiamante (es. AuthService) gestire gli errori 401.
        // Lanciamo sempre un errore con il messaggio del server.
        const error = new Error(responseData.message || `Errore HTTP: ${response.status}`);
        error.status = response.status;
        error.data = responseData;
        throw error;
      }

      // Aggiungiamo i dati della risposta all'oggetto per coerenza
      //return { data: responseData };
      return responseData;

    } catch (error) {
      console.error('ApiService Error:', error.message);
      // Rilancia l'errore per poterlo gestire nel punto in cui viene chiamata la funzione
      throw error;
    } finally {
      if (!skipLoader) {
        loaderService.hide();
      }
    }
  }

  get(endpoint, options = {}) {
    return this._request(endpoint, { ...options, method: 'GET' });
  }

  post(endpoint, data, options = {}) {
    return this._request(endpoint, { ...options, method: 'POST', body: data });
  }

  patch(endpoint, data, options = {}) {
    return this._request(endpoint, { ...options, method: 'PATCH', body: data });
  }

  put(endpoint, data, options = {}) {
    return this._request(endpoint, { ...options, method: 'PUT', body: data });
  }

  delete(endpoint, options = {}) {
    return this._request(endpoint, { ...options, method: 'DELETE' });
  }
}

export const apiService = new ApiService();